import { ENVIRONMENT } from "@/constants/constants";
import { GOOGLE_ADS_CONVERSION_ID } from "@/constants/googleAds";

export const fireGoogleAdsConversion = ({
  conversionLabel,
  additionalData,
}: {
  conversionLabel: string;
  additionalData: Record<string, unknown> | null;
}) => {
  if (ENVIRONMENT !== "production") {
    return;
  }

  const gtag = (window as { gtag?: (...args: unknown[]) => void }).gtag;

  if (gtag === null || gtag === undefined) {
    return;
  }

  gtag("event", "conversion", {
    send_to: `${GOOGLE_ADS_CONVERSION_ID}/${conversionLabel}`,
    transport_type: "beacon",
    ...additionalData,
  });
};
